import { login, register, logout } from '@/api/auth'
import { getUserInfo, getUserPermissions, changePassword, resetPassword } from '@/api/user'
import { getToken, setToken, removeToken, getUserInfo as getLocalUserInfo, setUserInfo, removeUserInfo, getPermissions, setPermissions, removePermissions } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: getLocalUserInfo(),
  permissions: getPermissions()
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    setToken(token)
  },
  SET_USERINFO(state, userInfo) {
    state.userInfo = userInfo
    setUserInfo(userInfo)
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
    setPermissions(permissions)
  },
  RESET_STATE(state) {
    state.token = ''
    state.userInfo = null
    state.permissions = []
    removeToken()
    removeUserInfo()
    removePermissions()
  }
}

const actions = {
  async login({ commit, dispatch }, loginForm) {
    const res = await login(loginForm)
    commit('SET_TOKEN', res.data.token)
    commit('SET_USERINFO', res.data.userInfo)
    // 确保token已保存后再获取权限
    await new Promise(resolve => setTimeout(resolve, 100))
    await dispatch('getUserPermissions')
    return res
  },

  async register({ commit }, registerForm) {
    const res = await register({
      username: registerForm.username,
      password: registerForm.password,
      email: registerForm.email
    })
    return res
  },

  async getUserInfo({ commit, dispatch }) {
    const res = await getUserInfo()
    commit('SET_USERINFO', res.data)
    await dispatch('getUserPermissions')
    return res
  },

  async getUserPermissions({ commit }) {
    try {
      const res = await getUserPermissions()
      if (res.code === 200 && res.data) {
        commit('SET_PERMISSIONS', res.data)
        console.log('获取到的用户权限:', res.data)
      } else {
        console.error('获取用户权限失败:', res)
      }
    } catch (error) {
      console.error('获取用户权限失败', error)
      throw error
    }
  },

  async changePassword({ state, commit }, { oldPassword, newPassword }) {
    const res = await changePassword({ oldPassword, newPassword })
    // 检查是否需要重新登录
    if (res.data && res.data.needRelogin) {
      // 密码已修改，需要退出登录
      commit('RESET_STATE')
    }
    return res
  },

  async resetPassword({ commit }) {
    const res = await resetPassword()
    // 检查是否需要重新登录
    if (res.data && res.data.needRelogin) {
      // 密码已重置，需要退出登录
      commit('RESET_STATE')
    }
    return res
  },

  async logout({ commit }) {
    await logout()
    commit('RESET_STATE')
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  permissions: state => state.permissions,
  hasPermission: state => permissionCode => {
    return state.permissions.some(p => p.permissionCode === permissionCode)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
